// Single-player detection from the wire snapshot.
//
// The sim publishes fog-of-war visibility per player. In single-player we
// don't want any fog at all — the player should see the whole map from
// frame one. The cleanest signal that this is a single-player match is
// counting human players in `globals.players` (built from `isHuman` on the
// `CPlayer` component). (Audit 2026-07-16 visual finding.)

import type { GameSnapshot } from '@aod/protocol';

interface PlayerGlobal {
  readonly playerIndex?: number;
  readonly isHuman?: boolean;
}

function readPlayers(snapshot: GameSnapshot): readonly PlayerGlobal[] {
  const globals = snapshot.state.globals as { players?: ReadonlyArray<PlayerGlobal> } | undefined;
  return globals?.players ?? [];
}

export function isSinglePlayerSnapshot(snapshot: GameSnapshot): boolean {
  const humans = readPlayers(snapshot).filter((p) => p.isHuman === true);
  return humans.length === 1;
}
